class BundleDrawer extends DrawerComponent {
  constructor() {
    super();
    //this.addProductSelectionHandler();
  }

  show(focusElement = null, animate = true) {
    super.show(focusElement, animate);

    if (focusElement && focusElement.name) {
      const titleElement = this.querySelector("#bundle-drawer-title span");
      if (titleElement) {
        titleElement.textContent = focusElement.name;
      }
    }
    this.currentTarget = focusElement;
  }

  addProductSelectionHandler() {
    this.addEventListener("click", (event) => {
      const productCard = event.target.closest(".bundle-product-card");
      if (productCard && this.currentTarget) {
        const productImage = productCard.querySelector(
          ".bundle-product-image"
        ).src;
        const productId = productCard.getAttribute("data-product-id");
        const productName = productCard.getAttribute("data-product-name");

        if (this.currentTarget.classList.contains("unlimited-bundle")) {
          // Create new bundle item
          const newBundleItem = this.createNewUnlimitedBundleItem(
            productImage,
            productId,
            productName
          );

          // Insert before the "Add Item" button
          const container = document.getElementById(
            "unlimited-bundle-container"
          );
          container.insertBefore(newBundleItem, this.currentTarget);
        } else {
          // Handle regular bundle items
          this.currentTarget.setAttribute("data-product-id", productId);
          const targetBox =
            this.currentTarget.querySelector(".bundle-item-box");
          if (targetBox) {
            targetBox.innerHTML = `<img src="${productImage}" class="selected-bundle-image animate" alt="Selected Product">
                    <button class="remove-bundle-item" onclick="this.closest('.bundle-item').remove()">
        <svg class="quit" viewBox="0 0 20 20"><path d="M18.75 18.75L1.25 1.25M18.75 1.25L1.25 18.75" stroke="#121212" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>`;
            targetBox.classList.add("filled-bundle-item");
          }
        }

        this.hide();
      }
    });
  }

  createNewUnlimitedBundleItem(productImage, productId, productName) {
    const div = document.createElement("div");
    div.classList.add("bundle-item", "unlimited-bundle");

    div.setAttribute("data-product-id", productId);

    div.innerHTML = `
      <div class="bundle-item-box filled-bundle-item">
        <img src="${productImage}" class="selected-bundle-image animate" alt="Selected Product">
        <button class="remove-bundle-item" onclick="this.closest('.bundle-item').remove()">
        <svg class="quit" viewBox="0 0 20 20"><path d="M18.75 18.75L1.25 1.25M18.75 1.25L1.25 18.75" stroke="#121212" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
      </div>
      <p class="bundle-item-text">${productName}</p>
    `;

    return div;
  }
}

customElements.define("bundle-drawer", BundleDrawer);
